import { AuthContainer } from "../container/AuthContainer.tsx";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { ArrowBackOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { fetchWithError } from "../utils/fetchWithError.ts";
import { useSnackbar } from 'notistack';
import { AnimatedPasswordCheck } from "../components/PasswordCheck.tsx";
import { isStrongPassword } from "../../../src/shared";
import { useVerificationCode } from "../hooks/useVerificationCode.ts";

export const ResetPasswordScreen = () => {

    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [showPasswordHint, setShowPasswordHint] = useState(false);

    const nav = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const {index, code} = useVerificationCode();
    
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const pwd = isStrongPassword(password);
        if(!pwd.isStrongPassword) {
            setShowPasswordHint(true);
            enqueueSnackbar("Dein Passwort ist zu schwach!", { variant: 'warning' });
            return;
        }

        if (password !== passwordRepeat) {
            enqueueSnackbar("Deine Passwörter stimmen nicht überein!", { variant: 'error' });
            return;
        }
        const baseUrl = "/auth/reset-password";
        const url = new URL(baseUrl, window.location.origin);

        try {
            const data = await fetchWithError(url.toString(), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    password,
                    index,
                    code
                })
            });
            
            if(data.success) {
                enqueueSnackbar("Dein Passwort wurde erfolgreich geändert!", { variant: 'success' });
                setTimeout(() => {
                    window.location.replace("/app/login");
                }, 1500);
            }
        } catch (error) {
            // Display the specific error message from the backend
            if (error instanceof Error) {
                enqueueSnackbar(error.message, { variant: 'error' });
            } else {
                enqueueSnackbar("Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie den Vorgang erneut.", { variant: 'error' });
            }
        }
    }

    return <AuthContainer>
        <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2}}>
            <Typography
                component={"h1"}
                variant={"h5"}
            >Passwort zurücksetzen</Typography>
            <IconButton onClick={()=>nav(-1)}>
                <ArrowBackOutlined />
            </IconButton>
        </Box>
        <Box component={"form"} onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
                name={"password"}
                label={"Neues Passwort"}
                fullWidth
                required
                type={"password"}
                sx={{ mb: 2 }}
                onChange={(e) => {
                    setPassword(e.currentTarget.value);
                    if (!showPasswordHint) {
                        setShowPasswordHint(true);
                    }
                }}
            />
            <Box sx={{ mb: 2 }}>
                <AnimatedPasswordCheck
                    show={showPasswordHint && !isStrongPassword(password).isStrongPassword}
                    password={password}
                />
            </Box>
            <TextField
                name={"confirmPassword"}
                label={"Neues Passwort bestätigen"}
                fullWidth
                required
                type={"password"}
                sx={{ mb: 2 }}
                onChange={(e) => setPasswordRepeat(e.target.value)}
            />
        <Button
            fullWidth
            variant={"contained"}
            type={"submit"}
            sx={{ mb: 2 }}
        >
            Absenden
        </Button>
        </Box>
  </AuthContainer>;
};